/* eslint react/no-unused-state: 0 */
import PropTypes from 'prop-types';
import React from 'react';
import { GroupList } from './GroupList';

export class GroupListPanel extends React.Component {
  render() {
    return (
      <ul className="list-group custom-list theme" key="education-articles" >
      {
        Object.keys(this.props.groups).map((group, index) =>
          [
            this.props.groups[group].title ?
              <li key={ this.props.groups[group].keyIndex } className="list-group-item list-group-item-top-header">
                { this.props.groups[group].title }
              </li> :
              null,
            <GroupList key={ index } actionItemType={ this.props.actionItemType }
              subGroups={ this.props.groups[group].subGroups }
              groupIndex={ index } groupTitle={ this.props.groups[group].title }
            />,
          ])
      }
      </ul>
    );
  }
}

GroupListPanel.propTypes = {
  title: PropTypes.object,
  groups: PropTypes.array,
  actionItemType: PropTypes.string,
};
